
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcceptServiceLevelChangeRequest,
  AdminForceServiceLevelChangeRequest,
  CreateServiceLevelRequest,
  DeclineServiceLevelChangeRequest,
  ServiceLevelDetailResource,
  ServiceLevelHistoryResource,
  ServiceLevelResource,
  ServiceLevelStatusResource,
  UpdateServiceLevelRequest,
} from '../models';
import {
    AcceptServiceLevelChangeRequestFromJSON,
    AcceptServiceLevelChangeRequestToJSON,
    AdminForceServiceLevelChangeRequestFromJSON,
    AdminForceServiceLevelChangeRequestToJSON,
    CreateServiceLevelRequestFromJSON,
    CreateServiceLevelRequestToJSON,
    DeclineServiceLevelChangeRequestFromJSON,
    DeclineServiceLevelChangeRequestToJSON,
    ServiceLevelDetailResourceFromJSON,
    ServiceLevelDetailResourceToJSON,
    ServiceLevelHistoryResourceFromJSON,
    ServiceLevelHistoryResourceToJSON,
    ServiceLevelResourceFromJSON,
    ServiceLevelResourceToJSON,
    ServiceLevelStatusResourceFromJSON,
    ServiceLevelStatusResourceToJSON,
    UpdateServiceLevelRequestFromJSON,
    UpdateServiceLevelRequestToJSON,
} from '../models';

export interface AcceptServiceLevelChangeRequestRequest {
    organizationId: string;
    acceptServiceLevelChangeRequest: AcceptServiceLevelChangeRequest;
}

export interface DeclineServiceLevelChangeRequestRequest {
    organizationId: string;
    declineServiceLevelChangeRequest: DeclineServiceLevelChangeRequest;
}

export interface FindServiceLevelDetailRequest {
    serviceLevelId: string;
}

export interface ForceServiceLevelChangeRequest {
    organizationId: string;
    adminForceServiceLevelChangeRequest: AdminForceServiceLevelChangeRequest;
}

export interface GetServiceLevelHistoryRequest {
    organizationId: string;
}

export interface NewConfigurationRequest {
    serviceLevelId: string;
    createServiceLevelRequest: CreateServiceLevelRequest;
}

export interface UpdateConfigurationRequest {
    serviceLevelId: string;
    configurationId: string;
    updateServiceLevelRequest: UpdateServiceLevelRequest;
}

/**
 * 
 */
export class ServiceLevelAdminApi extends runtime.BaseAPI {

    /**
     * Accept a service level change request for an organization
          */
    async acceptServiceLevelChangeRequestRaw(requestParameters: AcceptServiceLevelChangeRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelStatusResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling acceptServiceLevelChangeRequest().'
            );
        }

        if (requestParameters['acceptServiceLevelChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'acceptServiceLevelChangeRequest',
                'Required parameter "acceptServiceLevelChangeRequest" was null or undefined when calling acceptServiceLevelChangeRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ServiceLevelStatusResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/change-request/accept`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptServiceLevelChangeRequestToJSON(requestParameters['acceptServiceLevelChangeRequest']),
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Accept a service level change request for an organization
          */
    async acceptServiceLevelChangeRequest(organizationId: string, acceptServiceLevelChangeRequest: AcceptServiceLevelChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelStatusResource> {
        const response = await this.acceptServiceLevelChangeRequestRaw({ organizationId: organizationId, acceptServiceLevelChangeRequest: acceptServiceLevelChangeRequest }, initOverrides);
        return response._data;
    }

    /**
     * Decline a service level change request for an organization
          */
    async declineServiceLevelChangeRequestRaw(requestParameters: DeclineServiceLevelChangeRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelStatusResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling declineServiceLevelChangeRequest().'
            );
        }

        if (requestParameters['declineServiceLevelChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'declineServiceLevelChangeRequest',
                'Required parameter "declineServiceLevelChangeRequest" was null or undefined when calling declineServiceLevelChangeRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ServiceLevelStatusResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/change-request/decline`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeclineServiceLevelChangeRequestToJSON(requestParameters['declineServiceLevelChangeRequest']),
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Decline a service level change request for an organization
          */
    async declineServiceLevelChangeRequest(organizationId: string, declineServiceLevelChangeRequest: DeclineServiceLevelChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelStatusResource> {
        const response = await this.declineServiceLevelChangeRequestRaw({ organizationId: organizationId, declineServiceLevelChangeRequest: declineServiceLevelChangeRequest }, initOverrides);
        return response._data;
    }

    /**
     * GET client-settings/api/servicelevels
          */
    async findAllRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ServiceLevelResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ServiceLevelResource>>({
            path: `/client-settings/api/servicelevels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ServiceLevelResourceFromJSON);
        return response;
    }

    /**
     * GET client-settings/api/servicelevels
          */
    async findAll(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ServiceLevelResource>> {
        const response = await this.findAllRaw(initOverrides);
        return response._data;
    }

    /**
     * GET client-settings/api/servicelevels/{serviceLevelId}
          */
    async findServiceLevelDetailRaw(requestParameters: FindServiceLevelDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelDetailResource>> {
        if (requestParameters['serviceLevelId'] == null) {
            throw new runtime.RequiredError(
                'serviceLevelId',
                'Required parameter "serviceLevelId" was null or undefined when calling findServiceLevelDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ServiceLevelDetailResource>({
            path: `/client-settings/api/servicelevels/{serviceLevelId}`.replace(`{${"serviceLevelId"}}`, encodeURIComponent(String(requestParameters['serviceLevelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelDetailResourceFromJSON(response._data); }
        return response;
    }

    /**
     * GET client-settings/api/servicelevels/{serviceLevelId}
          */
    async findServiceLevelDetail(serviceLevelId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelDetailResource> {
        const response = await this.findServiceLevelDetailRaw({ serviceLevelId: serviceLevelId }, initOverrides);
        return response._data;
    }

    /**
     * Directly force a service level change for an organization (platform admin only)
          */
    async forceServiceLevelChangeRaw(requestParameters: ForceServiceLevelChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelStatusResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling forceServiceLevelChange().'
            );
        }

        if (requestParameters['adminForceServiceLevelChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'adminForceServiceLevelChangeRequest',
                'Required parameter "adminForceServiceLevelChangeRequest" was null or undefined when calling forceServiceLevelChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ServiceLevelStatusResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/change-request/force`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminForceServiceLevelChangeRequestToJSON(requestParameters['adminForceServiceLevelChangeRequest']),
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Directly force a service level change for an organization (platform admin only)
          */
    async forceServiceLevelChange(organizationId: string, adminForceServiceLevelChangeRequest: AdminForceServiceLevelChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelStatusResource> {
        const response = await this.forceServiceLevelChangeRaw({ organizationId: organizationId, adminForceServiceLevelChangeRequest: adminForceServiceLevelChangeRequest }, initOverrides);
        return response._data;
    }

    /**
     * Get given organization\'s service level history
          */
    async getServiceLevelHistoryRaw(requestParameters: GetServiceLevelHistoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ServiceLevelHistoryResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getServiceLevelHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ServiceLevelHistoryResource>({
            path: `/client-settings/api/organization/{organizationId}/service-level/history`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ServiceLevelHistoryResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get given organization\'s service level history
          */
    async getServiceLevelHistory(organizationId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ServiceLevelHistoryResource> {
        const response = await this.getServiceLevelHistoryRaw({ organizationId: organizationId }, initOverrides);
        return response._data;
    }

    /**
     * POST client-settings/api/servicelevels/{serviceLevelId}/configuration
          */
    async newConfigurationRaw(requestParameters: NewConfigurationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['serviceLevelId'] == null) {
            throw new runtime.RequiredError(
                'serviceLevelId',
                'Required parameter "serviceLevelId" was null or undefined when calling newConfiguration().'
            );
        }

        if (requestParameters['createServiceLevelRequest'] == null) {
            throw new runtime.RequiredError(
                'createServiceLevelRequest',
                'Required parameter "createServiceLevelRequest" was null or undefined when calling newConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/servicelevels/{serviceLevelId}/configuration`.replace(`{${"serviceLevelId"}}`, encodeURIComponent(String(requestParameters['serviceLevelId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateServiceLevelRequestToJSON(requestParameters['createServiceLevelRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST client-settings/api/servicelevels/{serviceLevelId}/configuration
          */
    async newConfiguration(serviceLevelId: string, createServiceLevelRequest: CreateServiceLevelRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.newConfigurationRaw({ serviceLevelId: serviceLevelId, createServiceLevelRequest: createServiceLevelRequest }, initOverrides);
    }

    /**
     * POST client-settings/api/servicelevels/{serviceLevelId}/configuration/{configurationId}
          */
    async updateConfigurationRaw(requestParameters: UpdateConfigurationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['serviceLevelId'] == null) {
            throw new runtime.RequiredError(
                'serviceLevelId',
                'Required parameter "serviceLevelId" was null or undefined when calling updateConfiguration().'
            );
        }

        if (requestParameters['configurationId'] == null) {
            throw new runtime.RequiredError(
                'configurationId',
                'Required parameter "configurationId" was null or undefined when calling updateConfiguration().'
            );
        }

        if (requestParameters['updateServiceLevelRequest'] == null) {
            throw new runtime.RequiredError(
                'updateServiceLevelRequest',
                'Required parameter "updateServiceLevelRequest" was null or undefined when calling updateConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/servicelevels/{serviceLevelId}/configuration/{configurationId}`.replace(`{${"serviceLevelId"}}`, encodeURIComponent(String(requestParameters['serviceLevelId']))).replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters['configurationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateServiceLevelRequestToJSON(requestParameters['updateServiceLevelRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST client-settings/api/servicelevels/{serviceLevelId}/configuration/{configurationId}
          */
    async updateConfiguration(serviceLevelId: string, configurationId: string, updateServiceLevelRequest: UpdateServiceLevelRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateConfigurationRaw({ serviceLevelId: serviceLevelId, configurationId: configurationId, updateServiceLevelRequest: updateServiceLevelRequest }, initOverrides);
    }

}
